import React, { useEffect } from "react";
import MainPage from "../MainPage";
import SessionStorage from "../../Constants/SessionStorage";
import { AppStorageKeys, DeviceManagePaths } from "../../Constants/Constants";
import { getRedirectQueryParams, listener } from "../../Constants/Utilities";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

export const SupportView = (props) => {
  const { protocol, hostname } = window.location;
  const history = useHistory();
  const dispatch = useDispatch();
  const deviceManageUrl =
    protocol + "//" + hostname + ":" + ENV_VARS.DEVICE_MANAGE_PORT;
  const redirectUrl = getRedirectQueryParams(DeviceManagePaths.home);

  useEffect(() => {
    listener(history, dispatch);
  }, []);

  return (
    <MainPage iframe={true}>
      <iframe
        title="SupportView"
        className="new-frame"
        src={deviceManageUrl + "/login?" + redirectUrl}
      />
    </MainPage>
  );
};

export default SupportView;
